import React, { useState, useEffect } from 'react';
import './ConferenceCountdown.css';

function ConferenceCountdown({ language }) {
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [loading, setLoading] = useState(true);

  // Conference date: April 11, 2026 9:00 AM Beijing Time
  const conferenceDate = new Date('2026-04-11T09:00:00+08:00').getTime();

  const texts = {
    zh: {
      title: '会议倒计时',
      conferenceDate: '2026年4月11日 09:00',
      days: '天',
      hours: '时',
      minutes: '分',
      seconds: '秒',
      started: '会议进行中',
      startedDesc: '会议已开始'
    },
    en: {
      title: 'CONFERENCE COUNTDOWN',
      conferenceDate: 'Apr 11, 2026 09:00 (Beijing)',
      days: 'DAYS',
      hours: 'HRS',
      minutes: 'MIN',
      seconds: 'SEC',
      started: 'CONFERENCE IN PROGRESS',
      startedDesc: 'The conference has started'
    }
  };

  const currentTexts = texts[language] || texts.en;

  useEffect(() => {
    let intervalId;

    const calculateRemaining = () => {
      const now = Date.now();
      const remaining = Math.max(0, conferenceDate - now);
      setTimeRemaining(remaining);
      setLoading(false);

      if (remaining <= 0 && intervalId) {
        clearInterval(intervalId);
      }
    };

    calculateRemaining();
    intervalId = setInterval(calculateRemaining, 1000);

    return () => clearInterval(intervalId);
  }, [conferenceDate]);

  const formatTime = (ms) => {
    if (ms === null || ms <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
    const seconds = totalSeconds % 60;
    
    return { days, hours, minutes, seconds };
  };

  const padZero = (num) => String(num).padStart(2, '0');

  const time = formatTime(timeRemaining);
  const isStarted = timeRemaining !== null && timeRemaining <= 0;

  if (loading) {
    return (
      <div className="conference-countdown-container">
        <div className="conference-countdown-loading">
          <div className="conference-loading-spinner"></div>
        </div>
      </div>
    );
  }

  // Conference started state
  if (isStarted) {
    return (
      <div className="conference-countdown-container started">
        <div className="conference-countdown-frame">
          <div className="conference-countdown-corner tl"></div>
          <div className="conference-countdown-corner tr"></div>
          <div className="conference-countdown-corner bl"></div>
          <div className="conference-countdown-corner br"></div>
          
          <div className="conference-countdown-started">
            <div className="conference-started-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12,6 12,12 16,14"/>
              </svg>
            </div>
            <h2 className="conference-started-title">{currentTexts.started}</h2>
            <p className="conference-started-desc">{currentTexts.startedDesc}</p>
          </div>
          
          <div className="conference-countdown-scanline"></div>
        </div>
      </div>
    );
  }

  // Active countdown
  return (
    <div className="conference-countdown-container">
      <div className="conference-countdown-frame">
        <div className="conference-countdown-corner tl"></div>
        <div className="conference-countdown-corner tr"></div>
        <div className="conference-countdown-corner bl"></div>
        <div className="conference-countdown-corner br"></div>
        
        <div className="conference-countdown-header">
          <div className="conference-countdown-status-light"></div>
          <span className="conference-countdown-title">{currentTexts.title}</span>
        </div>
        
        <div className="conference-countdown-date-info">
          <span className="conference-date">{currentTexts.conferenceDate}</span>
        </div>
        
        <div className="conference-countdown-display">
          <div className="conference-countdown-unit">
            <div className="conference-countdown-value-wrapper">
              <span className="conference-countdown-value">{time.days}</span>
              <div className="conference-value-glow"></div>
            </div>
            <span className="conference-countdown-label">{currentTexts.days}</span>
          </div>
          
          <div className="conference-countdown-separator">:</div>
          
          <div className="conference-countdown-unit">
            <div className="conference-countdown-value-wrapper">
              <span className="conference-countdown-value">{padZero(time.hours)}</span>
              <div className="conference-value-glow"></div>
            </div>
            <span className="conference-countdown-label">{currentTexts.hours}</span>
          </div>
          
          <div className="conference-countdown-separator">:</div>
          
          <div className="conference-countdown-unit">
            <div className="conference-countdown-value-wrapper">
              <span className="conference-countdown-value">{padZero(time.minutes)}</span>
              <div className="conference-value-glow"></div>
            </div>
            <span className="conference-countdown-label">{currentTexts.minutes}</span>
          </div>
          
          <div className="conference-countdown-separator blink">:</div>
          
          <div className="conference-countdown-unit seconds">
            <div className="conference-countdown-value-wrapper">
              <span className="conference-countdown-value">{padZero(time.seconds)}</span>
              <div className="conference-value-glow pulse"></div>
            </div>
            <span className="conference-countdown-label">{currentTexts.seconds}</span>
          </div>
        </div>
        
        <div className="conference-countdown-progress">
          <div className="conference-progress-track">
            <div className="conference-progress-bar"></div>
            <div className="conference-progress-glow"></div>
          </div>
        </div>
        
        <div className="conference-countdown-scanline"></div>
        <div className="conference-countdown-noise"></div>
      </div>
    </div>
  );
}

export default ConferenceCountdown;
